namespace TR {
    type TripService = Core.TripService;
    class ClickTripz {
        constructor(private $routeParams,
                    private tripService: TripService,
                    private loaderService) {
            if ($routeParams.tripId
                && _.includes(TRPCONFIG.Domain.ClickTripzProviders, $routeParams.source)
                && !window.document.getElementById('click-tripz')) {

                tripService.getTripNumberOfNights(0, $routeParams.tripId).then(numberOfNights => {
                    if (_.includes(TRPCONFIG.Domain.ClickTripzNumberOfNights, numberOfNights)) {
                        loaderService.loadJS(window.document, 'script', 'click-tripz', TRPCONFIG.Domain.ClickTripzURL);
                    }
                });
            }
        }
    }

    angular
        .module('TR')
        .directive('clickTripz', (): ng.IDirective => {
            return {
                controller: ClickTripz,
            };
        });

}
